import{theme as r}from"./theme.js";const t=t=>{if(!t)return;const[o,e]=t.split(".");return r.color[o][e]};export{t as getSemanticColor};
//# sourceMappingURL=getSemanticColor.js.map
